import styled from 'styled-components';

export const LimitMessageStyled = styled.p`
  margin-top: 10px;
  text-align: center;

  ${({ theme }) => `
    font-weight: ${theme.fontWeights.semibold};
    color: ${theme.primaryColour};
  `}
`;
